import { useTranslation } from 'react-i18next';
import { Box, Center, Spinner, Text, VStack } from '@chakra-ui/react';
import { HiShieldCheck } from 'react-icons/hi2';
import { OnePageHeader as PageHeader } from '@/components/layout/OnePageHeader';
import { EventCard } from '@/components/EventCard';
import { useNotificationsDrawer } from '@/contexts/NotificationsDrawerContext';
import { useAllEvents, useUnreadCount } from '@/hooks/useReunification';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export default function Events() {
  const { t } = useTranslation();
  useDocumentTitle(t('events.title'));
  const { open: openNotifications } = useNotificationsDrawer();
  const { data: unreadData } = useUnreadCount();
  const unreadCount = unreadData?.unread_count ?? 0;
  const { data, isLoading } = useAllEvents();
  const events = data?.results ?? [];

  const active = events.filter((e) => e.status === 'active');
  const past = events.filter((e) => e.status !== 'active');

  return (
    <Box>
      <PageHeader
        icon={HiShieldCheck}
        title={t('events.title')}
        subtitle={t('events.subtitle')}
        showSearch={false}
        showNotifications={true}
        onNotificationClick={openNotifications}
        notificationCount={unreadCount}
        showColorMode={false}
      />

      <Box p={{ base: 4, md: 6 }}>
        {isLoading ? (
          <Center py={12}>
            <Spinner size="lg" />
          </Center>
        ) : (
          <>
            {active.length > 0 && (
              <Box mb={6}>
                <Text fontSize="md" fontWeight="600" color="text.primary" mb={3}>
                  {t('events.active')}
                </Text>
                <VStack gap={3} align="stretch">
                  {active.map((event) => (
                    <EventCard key={event.public_id} event={event} />
                  ))}
                </VStack>
              </Box>
            )}

            {past.length > 0 && (
              <Box>
                <Text fontSize="md" fontWeight="600" color="text.primary" mb={3}>
                  {t('events.past')}
                </Text>
                <VStack gap={3} align="stretch">
                  {past.map((event) => (
                    <EventCard key={event.public_id} event={event} />
                  ))}
                </VStack>
              </Box>
            )}

            {events.length === 0 && (
              <Box textAlign="center" py={12}>
                <Text fontSize="lg" color="text.secondary">
                  {t('events.empty')}
                </Text>
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
}
